var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"mode":"in-out","name":"fade"}},[_c('div',{staticClass:"loader-wrapper loader-static"},[_c('div',{staticClass:"loader",class:{ dark: _vm.dark, white: _vm.light },style:({ height: _vm.size, width: _vm.size })})])])}
var staticRenderFns = []

export { render, staticRenderFns }